/*eslint-disable*/
import { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../../../../utils/axiosInstance";

export default function useInventorySearch(query, update) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    setRows([]);
  }, [query, update]);

  useEffect(() => {
    var params = new URLSearchParams();
    params.append("page", query.page - 1);
    params.append("limit", query.pageSize);

    if (query.Stock) params.append("stockNumber_string", query.Stock);

    setLoading(true);
    setError(false);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    axiosInstance()
      .get("/api/v1/rules/almacen", {
        params,
        cancelToken: source.token,
      })
      .then((response) => {
        // console.log(response.data.data.Results);
        let result = response.data.data.Results;

        result.map((pase) => {
          pase.id = pase._id;
        });

        setRows(result);
        setTotalRows(parseInt(response.data.data.Total));
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        if (axios.isCancel(e)) return;
        setError(true);
      });
    return () => source.cancel();
  }, [query, update]);

  return { loading, error, rows, totalRows };
}
